module.exports = __webpack_public_path__ + "static/media/image_2_1.c57427d4.png";